<template>
   <div class="crud-wrapper">
      <crud-toolbar :modal-mode="modalMode" :new-state="newState" :title="modalTitle"
                    @onCommand="toolbarCommand"></crud-toolbar>

      <crud-form :modal-mode="modalMode" :ref="formName" v-model="validForm">

         <v-layout row wrap>

            <a-autocomplete-field :modalForm="ClientForm" :sm8="multiEnrollment" @onSelect="onClientSelect"
                                  allowEdit allowNew autofocus clearable label="Cliente / Tomador"
                                  modalWidth="550" placeholder="selecionar cliente" obj="client"
                                  ref="aafClient" v-model="formData.customerId" validate="required">
               <template slot="content" slot-scope="{data}">
                  <v-layout column>
                     <v-list-tile-title style="height: 22px;" v-text="data.name"></v-list-tile-title>
                     <v-list-tile-sub-title class="py-0">
                        {{data.federalId}} / Nasc.: {{data.birth? $moment(data.birth).format('DD/MM/YYYY'): "Data não definida"}}
                     </v-list-tile-sub-title>
                  </v-layout>
               </template>
            </a-autocomplete-field>

            <a-select-field :suggestions="clientData.jobs" @change="onEnrollmentSelect"
                            display-field="enrollment" label="N° Matrícula/Benefício" return-object
                            sm4 v-if="multiEnrollment" v-model="formData.selectedEnrollment"
                            validate="required"></a-select-field>
            <v-expand-transition origin="top left" v-if="formData.statusId != 0">
               <v-flex v-if="showCovenantExtraFields">
                  <v-layout row v-if="isINSS" wrap>
                     <a-text-field :validate="isRequired" label="Espécie" mask="###" v-model="formData.selectedEnrollment.benefitTypeId"></a-text-field>
                     <a-select-field :suggestions="inssPayMethod" @change="inssPayChange"
                                     label="Forma de Pagamento" sm6 v-model="formData.paymtType"
                                     validate="required"></a-select-field>
                     <v-flex class="caption grey--text py-1" sm6 xs12>
                        <v-flex class="outlined" xs12 style="max-height: 56px; border-radius:8px;">
                           <label class="aLabel text-xs-center" v-if="formData.paymtType === 1 && !askAcct">
                              Pagamento ocorrerá na <b>conta salário</b> que está informada no cadastro do cliente.
                           </label>
                           <label class="aLabel text-xs-center" v-if="formData.paymtType === 1 && askAcct">
                              <span class="font-weight-bold red--text">Conta salário não cadatrada</span> para o cliente.
                              Completar as informações abaixo.
                           </label>
                           <label class="aLabel text-xs-center" v-if="formData.paymtType === 2">
                              Se informar apenas banco e agência o pgto ocorrerá via <b>Ordem de Pagamento</b>
                           </label>
                           <label class="aLabel text-xs-center" v-if="formData.paymtType === null">
                              Escolha a forma de pagamento ao lado
                           </label>
                        </v-flex>
                     </v-flex>
                  </v-layout>

                  <v-layout row v-else-if="isSIAPE" wrap>
                     <a-text-field :validate="isRequired" label="UPAG" sm6
                                   v-model="formData.selectedEnrollment.upag"></a-text-field>
                     <a-text-field :validate="isRequired" label="Senha SIGEPE" sm6
                                   v-model="formData.selectedEnrollment.portalPin"></a-text-field>
                  </v-layout>
               </v-flex>
            </v-expand-transition>

            <v-expand-transition origin="top left" v-if="formData.statusId != 0">
               <v-flex v-if="askAcct" xs12>
                  <v-layout row wrap style="background-color: #ffffff; border-radius: 8px; margin-bottom: 10px;">
                     <v-flex pb-1 xs12>
                        <label class="subheading grey--text">Conta para Pagamento</label>
                     </v-flex>
                     <a-autocomplete-field :validate="isRequired" @change="bankPayChange" allow-new autoTrigger label="Banco" obj="bank" sm7
                                           v-if="askAcct" v-model="formData.paymtAcct.bankId">
                        <template slot="content" slot-scope="{data}">
                           {{`${data.bankNo} - ${data.name}`}}
                        </template>
                     </a-autocomplete-field>
                     <a-text-field :validate="isRequired" label="Agência" sm2 v-if="askAcct" v-mask="['###X', '####-X']"
                                   v-model="formData.paymtAcct.branchNo"></a-text-field>
                     <a-text-field :validate="isRequired" label="Conta Corrente" sm3 v-if="askAcct"
                                   v-mask="['###-X', '####-X', '#####-X', '######-X','#######-X',
                           '########-X','#########-X','##########-X','###########-X','############-X']"
                                   v-model="formData.paymtAcct.acctNo"></a-text-field>
                     <a-text-field v-if="isBankPayCaixa" label="Operação" sm4 v-mask="['###']" v-model="formData.paymtAcct.opNo"></a-text-field>
                  </v-layout>
               </v-flex>
            </v-expand-transition>

            <a-autocomplete-field sm8 :validate="isRequired" autoTrigger label="Banco do Contrato" obj="bank"
                                  v-model="formData.bankId">
               <template slot="content" slot-scope="{data}">
                  {{`${data.bankNo} - ${data.name}`}}
               </template>
            </a-autocomplete-field>
            <a-select-field label="Convênio" obj="covenant" sm4
                            v-model="formData.covenantId" validate="required"></a-select-field>
            <a-autocomplete-field :filter-by="{bankId: formData.bankId, covenantId: formData.covenantId}" v-if="formData.bankId != null"
                                  auto-trigger label="Tabela" obj="bankChart"
                                  v-model="formData.chartId"></a-autocomplete-field>

            <a-autocomplete-field :validate="isRequired" auto-trigger label="Tipo de Contrato" obj="productType" sm7
                                  v-model="formData.typeId"></a-autocomplete-field>
            <a-autocomplete-field auto-trigger label="Situação" obj="contractStatus"
                                  sm5 v-model="formData.statusId" validate="required"></a-autocomplete-field>

            <v-expand-transition origin="top left" v-if="formData.apiError">
               <v-flex xs12>
                  <v-layout row wrap style="background-color: #ffffff; border-radius: 8px; margin-bottom: 10px;">
                     <v-flex pb-1 xs12>
                        <label class="subheading grey--text">Error</label><br/>
                        <label style="color: #e94343; font-size: 16px; font-weight: bold;">{{ formData.apiError.error.data.mensagem }}</label><br/>
                        <label style="color: #262626;" v-for="detail in formData.apiError.error.data.detalhes" :key="detail">- {{ detail }}</label>
                     </v-flex>
                  </v-layout>
               </v-flex>
            </v-expand-transition>

            <v-expand-transition origin="top left">
               <v-flex v-if="askLastCTT" xs12>
                  <v-layout row wrap>
                     <v-flex pb-1 xs12>
                        <label class="subheading grey--text">Dados do Contrato Anterior</label>
                     </v-flex>
                     <v-expand-transition origin="top left">
                        <a-autocomplete-field :validate="isRequired" autoTrigger label="Banco"
                                              obj="bank" v-if="isPORTAB" v-model="formData.originalCttData.bankId">
                           <template slot="content" slot-scope="{data}">
                              {{`${data.bankNo} - ${data.name}`}}
                           </template>
                        </a-autocomplete-field>
                     </v-expand-transition>

                     <a-text-field :validate="isRequired" label="N° Contrato" sm4
                                   v-model="formData.originalCttData.number"></a-text-field>
                     <a-number-field :validate="isRequired" label="Valor da Parcela" number-mask="fixed_rs"
                                     sm4 v-model="formData.originalCttData.installment" v-on:blur="formData.installment = formData.originalCttData.installment"></a-number-field>
                     <a-text-field :validate="isRequired" hint="(prazo)" label="Restante" mask="###" sm4
                                   v-if="isPORTAB" v-model="formData.originalCttData.remaining"></a-text-field>
                     <a-number-field :validate="isRequired" label="Saldo Devedor" number-mask="fixed_rs"
                                     sm4 v-model="formData.originalCttData.balanceDue"></a-number-field>
                  </v-layout>
               </v-flex>
            </v-expand-transition>

            <v-flex pb-1 v-if="askLastCTT" xs12>
               <label class="subheading grey--text">Valores do Novo Contrato</label>
            </v-flex>
            <a-number-field :label="amountLabel" :sm4="!isCard" :sm6="isCard" :validate="isGtZero"
                            number-mask="fixed_rs" v-model="formData.amount"></a-number-field>
            <a-number-field :sm4="!isCard" :sm6="isCard" :validate="isGtZero" label="Valor da Parcela"
                            number-mask="fixed_rs" v-model="formData.installment"></a-number-field>
            <a-text-field :validate="isGtZero" label="Prazo Total" mask="###" sm4 v-if="!isCard"
                          v-model="formData.term"></a-text-field>

            <a-number-field disabled label="Troco Aproximado" number-mask="fixed_rs" sm4 v-if="askLastCTT"
                            v-model="formData.netAmount"></a-number-field>
            <a-number-field :offset-sm4="!askLastCTT" v-model="formData.interest" label="Taxa %" numberDecimals="1"
                            number-mask="p_rs" sm4 v-if="!isCard"></a-number-field>
            <a-number-field disabled label="Valor Total" number-mask="fixed_rs" sm4 v-if="!isCard"
                            v-model="totalAmount"></a-number-field>

            <a-text-area-field autoGrow label="Observações" v-model="formData.notes"></a-text-area-field>

         </v-layout>

         <template slot="rightContent">
            <v-expand-transition origin="top left" v-if="formData.benefitTypeId == 32 || clientData.age >= 78">
               <v-flex xs12>
                  <v-layout row wrap style="background-color: #ffffff; border-radius: 8px; margin-bottom: 10px;">
                     <v-flex pb-1 xs12>
                        <label class="subheading grey--text">Alerta</label><br/>
                        <label style="color: #ecae00; font-weight: bold;" v-if="formData.benefitTypeId == 32">- Cliente com benefício Aposentadoria por Invalidez Previdenciária (LOPS)<br/></label>
                        <label style="color: #ecae00; font-weight: bold;" v-if="clientData.age >= 78">- Cliente com mais de 78 anos de idade </label>
                     </v-flex>
                  </v-layout>
               </v-flex>
            </v-expand-transition>
            <div v-if="formData.customerId && clientData">
               <v-slide-y-transition mt-0 origin="top center" pt-0 tag="v-layout">
                  <v-card class="mb-4" color="rgba(0,0,0, 0.03)" flat key="card1" style="margin-top: -10px; border-radius:12px;"
                  >
                     <v-card-title class="pt-2 headline" primary-title>
                        <v-flex pa-0 xs10>
                            <label @click="editClient" class="text-truncate mt-2 aLink">{{clientData.name}}</label>
<!--                           <label class="text-truncate mt-2 aLink">{{clientData.name}}</label>-->
                        </v-flex>
                        <v-flex pa-0 style="height: 40px;" xs2>
                           <v-img :src="$config.imageUri(formData.selectedEnrollment.covenantLogo, 'smLogo')"
                                  contain height="40px"></v-img>
                        </v-flex>
                     </v-card-title>

                     <!--Client Data-->
                     <v-layout pt-0 px-3 row wrap>
                        <v-flex pt-0 xs4>
                           <label class="v-label  theme--light aLabel">CPF</label>
                           <label style="display: block;">{{clientData.federalId}}</label>
                        </v-flex>
                        <v-flex pt-0 xs4>
                           <label class="v-label  theme--light aLabel">Matrícula/Benefício</label>
                           <label style="display: block;">{{formData.selectedEnrollment.enrollment}}</label>
                        </v-flex>
                        <v-flex pt-0 xs4>
                           <label class="v-label  theme--light aLabel">Convênio</label>
                           <label style="display: block;">{{formData.selectedEnrollment.covenantName}}</label>
                        </v-flex>

                        <v-flex pt-0 xs4>
                           <label class="v-label  theme--light aLabel">Nascimento</label>
                           <label style="display: block;">
                              ({{clientData.age || '?'}} anos) {{clientData.birth? $moment(clientData.birth).format('DD/MM/YYYY'): "Data não definida"}}
                           </label>
                        </v-flex>
                        <v-flex pt-0 style="min-height: 40px;" xs4>
                           <label class="v-label  theme--light aLabel">Fone/Celular</label>
                           <label style="display: block;">{{clientData.mobileNumber}}</label>
                        </v-flex>
                        <v-flex pt-0 xs4>
                           <label class="v-label  theme--light aLabel">Tipo</label>
                           <label style="display: block;">{{formData.selectedEnrollment.categoryName}}</label>
                        </v-flex>

                        <v-flex pt-0 style="min-height: 40px;" xs4>
                           <label class="v-label  theme--light aLabel">Número RG</label>
                           <label style="display: block;">{{clientData.rgNumber}}</label>
                        </v-flex>
                        <v-flex pt-0 xs4>
                           <label class="v-label  theme--light aLabel">Órgão/UF RG</label>
                           <label style="display: block;">{{clientData.rgAgency}}</label>
                        </v-flex>
                        <v-flex pt-0 xs4>
                           <label class="v-label  theme--light aLabel">Expedição</label>
                           <label style="display: block;">{{clientData.rgIssueDate? $moment(clientData.rgIssueDate).format('DD/MM/YYYY'): "Data não definida"}}</label>
                        </v-flex>

                        <v-flex pt-0 style="min-height: 40px;" xs4>
                           <label class="v-label  theme--light aLabel">Natural de</label>
                           <label style="display: block;">{{clientData.bornCity}}</label>
                        </v-flex>
                        <v-flex pt-0 style="min-height: 40px;" xs8>
                           <label class="v-label  theme--light aLabel">Email</label>
                           <label style="display: block;">{{clientData.mainEmail}}</label>
                        </v-flex>

                        <v-flex xs12>
                           <v-divider class="mb-0"></v-divider>
                           <v-subheader class="pl-0" style="height: 30px">Conta Salário</v-subheader>
                        </v-flex>

                        <v-flex pt-0 style="min-height: 40px;" xs7>
                           <label class="v-label  theme--light aLabel">Banco</label>
                           <label style="display: block;">{{salaryBankName}}</label>
                        </v-flex>
                        <v-flex pt-0 style="min-height: 40px;" xs2>
                           <label class="v-label  theme--light aLabel">Agência</label>
                           <label style="display: block;">{{formData.paymtAcct.branchNo}}</label>
                        </v-flex>
                        <v-flex pt-0 xs3>
                           <label class="v-label  theme--light aLabel">Conta Corrente</label>
                           <label style="display: block;">{{formData.paymtAcct.acctNo}}</label>
                        </v-flex>
                        <v-flex pt-0 xs3 v-if="isBankPayCaixa && formData.paymtAcct.opNo">
                           <label class="v-label  theme--light aLabel">Operação</label>
                           <label style="display: block;">{{formData.paymtAcct.opNo}}</label>
                        </v-flex>

                        <v-flex xs12>
                           <v-divider></v-divider>
                           <v-subheader class="pl-0" style="height: 30px">Endereço</v-subheader>
                        </v-flex>

                        <v-flex pt-0 style="min-height: 40px;" xs12>
                           <label class="v-label  theme--light aLabel">Rua, número</label>
                           <label style="display: block;">{{clientData.address}}</label>
                        </v-flex>
                        <v-flex pt-0 style="min-height: 40px;" xs6>
                           <label class="v-label  theme--light aLabel">Complemento</label>
                           <label style="display: block;">{{clientData.address2}}</label>
                        </v-flex>
                        <v-flex pt-0 style="min-height: 40px;" xs6>
                           <label class="v-label  theme--light aLabel">Bairro</label>
                           <label style="display: block;">{{clientData.district}}</label>
                        </v-flex>
                        <v-flex pt-0 style="min-height: 40px;" xs6>
                           <label class="v-label  theme--light aLabel">Cidade/UF</label>
                           <label style="display: block;">{{clientData.city}}/{{clientData.state}}</label>
                        </v-flex>
                        <v-flex pt-0 style="min-height: 40px;" xs6>
                           <label class="v-label  theme--light aLabel">CEP</label>
                           <label style="display: block;">{{clientData.zipcode}}</label>
                        </v-flex>

                        <v-flex pt-0 style="min-height: 40px;" xs12>
                           <v-divider></v-divider>
                           <v-subheader class="pl-0" style="height: 30px">Observações</v-subheader>

                           <label style="display: block;">{{clientData.notes}}</label>
                        </v-flex>

                     </v-layout>

                  </v-card>
               </v-slide-y-transition>

               <v-slide-y-transition mt-0 origin="top center" pt-0>
                  <v-card color="rgba(0,0,0, 0.03)" flat style="margin-top: -10px; border-radius:8px;">
                     <v-card-title class="pt-2 title" primary-title>
                        Importe aqui imagens dos documentos do cliente
                     </v-card-title>
                     <v-card-text>
                        <file-pond
                                :server="this.cloudinaryUpload(this.$config.mediaStorage.uploadUrl, this.$config.mediaStorage.presets.customer.id)"
                                accepted-file-types="image/png, image/jpeg"
                                allow-multiple="true"
                                drop-on-page="true"
                                drop-validation="true"
                                instantUpload="false"
                                label-idle="Arraste e solte arquivos* aqui, ou clique para escolher..."
                                labelButtonAbortItemProcessing="Cancelar"
                                labelButtonProcessItem="Carregar"
                                labelButtonRemoveItem="Remover"
                                labelFileProcessingComplete="Upload concluído"
                                labelFileProcessingError="Erro no upload"
                                labelTapToCancel="cancelar"
                                labelTapToRetry="tentar novamente"
                                ref="pond">
                        </file-pond>
                     </v-card-text>
                  </v-card>
               </v-slide-y-transition>

               <v-slide-y-transition mt-0 origin="top center" pt-0>
                     <v-card class="mb-4" color="rgba(0,0,0, 0.03)" flat style="margin-top: -10px; border-radius:12px;">
                        <v-card-title>Documentos do Cliente</v-card-title>
                        <viewer :images="images">
                           <img style="max-height:200px; margin: 0px 5px; border-radius:8px;" v-for="src in images" :src="src" :key="src" />
                        </viewer>
                     </v-card>
               </v-slide-y-transition>
            </div>
         </template>

      </crud-form>

   </div>


</template>

<script>
    import CrudFormClass from '@consigmais-team/vue-common/layout/crudPage/crudFormClass';
    import "viewerjs/dist/viewer.css";
    import ClientForm from './ClientForm';
    import numeral from 'numeral';
    import vueFilePond from 'vue-filepond';

    export default CrudFormClass.extend({
        name: 'ContractForm',

        components: {
            FilePond: vueFilePond()
        },

        props: {
            customerId: {
                type: Number,
                required: false
            },
            kind: {
                type: String,
                required: false
            },
            statusId: {
                type: Number,
                required: false
            },
            formDataParam: {
               type: Object,
               required: false
            }
        },

        data: function () {
            return {
                title: 'Contrato',
                formName: 'contractForm',
                aux: 0,

                ClientForm,

                covenantList: [],

                inssPayMethod: [
                    {
                        id: 1,
                        name: 'Conta Corrente'
                    },
                    {
                        id: 2,
                        name: 'Cartão Magnético'
                    }
                ],

                toCTT: false,

                images: [],

                salaryBankName: null,

                auxBankPayOpNo: null,

                formData: Object.assign({
                    id: null,
                    companyId: this.$store.state.company.brand.id,
                    statusId: this.statusId == null ? 1 : this.statusId,
                    covenantId: null,
                    customerId: this.customerId,
                    enrollmentId: null,
                    bankId: null,
                    productId: null,
                    typeId: 10,
                    chartId: null,
                    enrollment: null,
                    paymtType: null,
                    paymtAcct: {},
                    type: 'E', //TYPE CONTRATO
                    kind: this.kind,
                    number: null,
                    issueDate: null,
                    amount: 0,
                    payback: 0,
                    selectedEnrollment: {},
                    installment: 0,
                    term: 0,
                    interest: 0,
                    cardAmount: 0,
                    startMonth: null,
                    endMonth: null,
                    originalCttData: {},
                    notes: null,
                    statusName: null,
                    covenantName: null,
                    userName: null,
                    file: null,
                    apiError: null,
                    benefitTypeId: null
                }, this.formDataParam),
                clientData: {}
            };
        },

        watch: {
            'formData.selectedEnrollment': {
               handler: function(v, oldVal) {
                  if(!this.isINSS){
                     this.formData.selectedEnrollment.benefitTypeId = null
                  }
               }
            },
            'formData.covenantId': function (value) {
               let auxCovenant = this.covenantList.find(co => co.id == value);
               if(auxCovenant){
                  this.formData.term = auxCovenant.maxTerm;
                  if(this.aux >= 2){
                     this.formData.chartId = null;
                  }else{
                     this.aux = this.aux +1;
                  }
               }
            },
            'formData.bankId': function () {
               if(this.aux >= 2){
                  this.formData.chartId = null;
               }else{
                  this.aux = this.aux +1;
               }
            },
            'formData.statusId': async function (newValue) {
                let selected = await this.$api.dataService.search('contractStatus', { id: newValue });
                if (selected) {
                    this.toCTT = (selected[0].kind !== 'EST');
                } else {
                    this.toCTT = false;
                }
            },
            'formData.customerId' (newValue) {
               if (!newValue) {
                  this.formData.paymtType = null;
                  this.formData.selectedEnrollment = {};
                  this.salaryBankName = null;
                  this.formData.paymtAcct = {};
               }

               if (newValue) {
                  this.$api.dataService.getData('contract/getFiles', { id: this.formData.customerId }).then(res =>{
                     if(res.file)
                        this.images = res.file.map(el => this.$config.imageUri(el.file, "photoBigger"));
                  });
               }
            }
        },
        computed: {
            contractKind () {
                return this.kind || 'EST';
            },

            isBankPayCaixa () {
               return this.formData.paymtAcct && (this.formData.paymtAcct.bankId === 22);
            },

            totalAmount () {
               return parseFloat(this.formData.installment) * parseFloat(this.formData.term);
            },

            payback () {
                let newAmount = parseFloat(this.formData.amount);
                let lastBalance = parseFloat(this.formData.originalCttData.balanceDue);
                return (newAmount > lastBalance) ? (newAmount - lastBalance) : 0;
            },

            multiEnrollment () {
                return (this.clientData && this.clientData.jobs && this.clientData.jobs.length > 1);
            },

            isINSS () {
                return this.formData.selectedEnrollment && (this.formData.selectedEnrollment.covenantId === 1);
            },

            isSIAPE () {
                return this.formData.selectedEnrollment && (this.formData.selectedEnrollment.covenantId === 2);
            },

            isPORTAB () {
                return (Math.trunc(this.formData.typeId / 10) === 3);
            },

            showCovenantExtraFields () {
                return this.isINSS || this.isSIAPE;
            },

            askAcct () {
                if (!this.formData.customerId) return false;

                let en = this.formData.selectedEnrollment;
                let hasAcct = (en.bankId && en.branchNo && en.acctNo);
                let type = +this.formData.paymtType;
                return ((type === 1) && !hasAcct) || (type === 2);
            },

            askLastCTT () {
                return ([2, 3].indexOf(Math.trunc(this.formData.typeId / 10)) >= 0);
            },

            isCard () {
                return ([5, 6].indexOf(Math.trunc(this.formData.typeId / 10)) >= 0);
            },

            isRequired () {
                let isEST = (this.contractKind === 'EST');
                return (isEST && this.toCTT) ? 'required' : '';
            },
            isGtZero () {
                let isEST = (this.contractKind === 'EST');
                return (isEST && this.toCTT) ? 'required,gtZero' : '';
            },

            amountLabel () {
                return (this.isCard) ? 'Valor do Saque' : 'Valor do Contrato';
            }

        },

        methods: {
            saveConfirmation(data){
               return new Promise((resolve, reject) => {
                  if(this.formData.selectedEnrollment.id){
                     if(data.selectedEnrollment){
                        data.selectedEnrollment.id = this.formData.selectedEnrollment.id
                     }else{
                        if(data.paymtAcct){
                           data.selectedEnrollment = {
                              id: this.formData.selectedEnrollment.id
                           }
                        }
                     }
                  }
                  resolve(true)
               });
            },
            renewEnrollmentId(){
               if(this.formData.selectedEnrollment.id){
                  if(typeof this.formData.selectedEnrollment.id == 'string'){
                     this.formData.selectedEnrollment.id = parseInt(this.formData.selectedEnrollment.id)
                  }else{
                     this.formData.selectedEnrollment.id = this.formData.selectedEnrollment.id.toString();
                  }
               }
            },
            async onClientSelect (data) {
                this.clientData = await this.$api.dataService.getById('client', data.id);
                if (this.clientData && Array.isArray(this.clientData.jobs)) {
                  let newEnrollment;
                  if(this.formData.enrollmentId)
                     newEnrollment = this.clientData.jobs.find(el => el.id == this.formData.enrollmentId)
                  if(!newEnrollment)
                     newEnrollment = this.clientData.jobs[0];

                  this.formData.covenantId = newEnrollment.covenantId;
                  this.salaryBankName = newEnrollment.salaryBankName;
                  this.formData.selectedEnrollment = newEnrollment;
                  this.enrollmentChange(newEnrollment);
                  // this.formData.paymtType = 1;
                }
            },

            async onEnrollmentSelect(data){
               let enrollmentId = data.id || this.formData.enrollmentId;
               this.clientData = await this.$api.dataService.getById('client', this.formData.customerId);
                if (this.clientData && Array.isArray(this.clientData.jobs)) {
                  let newEnrollment = this.clientData.jobs.find(el => el.id == enrollmentId)
                  this.salaryBankName = newEnrollment.salaryBankName;
                  this.formData.selectedEnrollment = newEnrollment;
                  this.enrollmentChange(newEnrollment);
                }
            },

            enrollmentChange (data) {
                let { bankId, branchNo, acctNo, opNo } = data;
                this.formData.enrollment = data.enrollment;
                this.formData.enrollmentId = data.id;
                this.formData.paymtAcct = {
                    bankId,
                    branchNo,
                    acctNo,
                    opNo
                };
            },
            bankPayChange (value){
               this.salaryBankName = `${value.bankNo} - ${value.name}`;
               if(value.id !== 22){
                  this.auxBankPayOpNo = this.formData.paymtAcct.opNo;
                  this.formData.paymtAcct.opNo = null;
               }else{
                  this.formData.paymtAcct.opNo = this.auxBankPayOpNo;
               }
            },
            inssPayChange (value) {
                if (value === 2 && this.formData.paymtAcct) {
                    this.formData.paymtAcct.acctNo = null;
                } else if (value === 1 && this.formData.paymtAcct && this.formData.selectedEnrollment) {
                    this.formData.paymtAcct.acctNo = this.formData.selectedEnrollment.acctNo;
                }
            },

            editClient () {
                this.$refs.aafClient.editRecord(this.formData.customerId);
            },

            cloudinaryUpload (url, unsignedUploadPreset) {
                return ({
                    process: (fieldName, file, metadata, load, error, progress, abort) => {

                        const xhr = new XMLHttpRequest();
                        const formData = new FormData();

                        xhr.open('POST', url, true);
                        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

                        xhr.upload.addEventListener('progress', e => {
                            progress(e.lengthComputable, e.loaded, e.total);
                        });

                        xhr.onreadystatechange = e => {

                            if (xhr.readyState !== 4) {
                                return;
                            }

                            if (xhr.status >= 200 && xhr.status < 300) {
                                const response = JSON.parse(xhr.responseText);
                                const publicId = response.publicId;
                                const resourceType = response.resourceType;
                                this.$api.dataService.postData('appUser/addDocuments', { customerId: this.formData.customerId,
                                    file: {
                                        publicId,
                                        resourceType
                                    },
                                    typeId: 6
                                });
                                load(response.publicId);
                                return;
                            }

                            error('oh no!');
                        };

                        formData.append('upload_preset', unsignedUploadPreset);
                        formData.append('tags', 'browser_upload');
                        formData.append('file', file);
                        xhr.send(formData);

                        return {
                            abort: () => {
                                xhr.abort();
                            }
                        };
                    },
                    revert: null
                });
            },
         },

         async created() {
            this.covenantList = await this.$api.dataService.search('covenant');
         }
    });
</script>

<style scoped>
   .bigNumber {
      font-size: 40px;
      font-weight: 400;
   }

   .biggerNumber {
      font-size: 60px;
      font-weight: 500;
      color: orange;
   }

   /* .filepond--panel-root {
    background: #ffffff !important;
    border-radius: 10px;
    opacity: 100% !important;
    z-index: 100000
}  */

</style>



// WEBPACK FOOTER //
// src/pages/ContractForm.vue